<template>
    <div class="color-picker-holder">
        <div
            @click="togglePicker()"
            :class="['color-box', {disabled}]"
            :style="{background: color}"
        />
        <component
            :is="`${variant}-picker`"
            v-if="isPickerVisible"
            v-click-outside="closeAllPickers"
            :class="['picker']"
            v-bind="$attrs"
            :value="color"
            @input="emitState"
        />
    </div>
</template>

<script>
import {
    Compact,
    Material,
    Slider,
    Swatches,
    Photoshop,
    Sketch,
    Chrome
} from 'vue-color'

export default {
    name: 'oc-color-picker',
    inheritAttrs: false,
    components: {
        'material-picker': (resolve) => resolve(Material),
        'compact-picker': (resolve) => resolve(Compact),
        'swatches-picker': (resolve) => resolve(Swatches),
        'slider-picker': (resolve) => resolve(Slider),
        'sketch-picker': (resolve) => resolve(Sketch),
        'chrome-picker': (resolve) => resolve(Chrome),
        'photoshop-picker': (resolve) => resolve(Photoshop)
    },
    props: {
        value: {
            default: '#ffffff'
        },
        variant: {
            type: String,
            default: 'chrome',
            validator: function (value) {
                return ['chrome', 'material', 'compact', 'swatches', 'slider', 'sketch', 'photoshop'].indexOf(value) !== -1
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value(newValue) {
            this.color = newValue
        }
    },
    data() {
        return {
            color: this.value,
            pickerState: false
        }
    },
    computed: {
        isPickerVisible() {
            return this.pickerState && this.disabled === false
        }
    },
    methods: {
        emitState($event) {
            this.color = $event.hex
            this.$emit('input', this.color)
        },
        closeAllPickers(e) {
            if( e.target.classList.contains('color-box') ) {
                return
            }

            this.pickerState = false
        },
        togglePicker() {
            this.pickerState = !this.pickerState
        }
    }
}
</script>

<style scoped>
.color-picker-holder {
    position: relative;
}

.color-picker-holder .picker {
    position: absolute;
    z-index: 99999;
    top: 0;
    left: 40px;
}

.color-picker-holder .color-box {
     width: 25px;
     height: 25px;
     border: solid 1px #ccc;
     border-radius: 5px;
     cursor: pointer;
}

.color-picker-holder .color-box.disabled {
    cursor: default;
}
</style>
